module.exports = __webpack_public_path__ + "static/media/190611_OmbreFontaine-02.cb1d97bd.png";